export default "https://cdn-static.gokick.com/assets/1c04a0e7cb9e690604c984af7e1d0f36647cf8e0/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";